import { makeTotalData } from '@/lib/aggutil'
import { callApi } from './common'

function summary(accountId, month) {
  return callApi(
    `billing/aggregate/${accountId}/${month.replace('-', '')}/summary`
  ).then(makeTotalData)
}

function dataTransfer(accountId, month) {
  return callApi(
    `billing/aggregate/${accountId}/${month.replace('-', '')}/data_transfer`
  ).then(makeTotalData)
}

function costAllocationTags(accountId, month) {
  return callApi(
    `billing/aggregate/${accountId}/${month.replace('-', '')}/cost_tags`
  ).then(makeTotalData)
}

function cdnUsage(accountId, month) {
  return callApi(
    `billing/aggregate/${accountId}/${month.replace('-', '')}/cdn_usage`
  ).then(makeTotalData)
}

function commitment(accountId, month) {
  return callApi(
    `billing/aggregate/${accountId}/${month.replace('-', '')}/commitment`
  ).then(makeTotalData)
}

function summaryByPeriod(accountId, month, kind, period) {
  return callApi(
    `billing/aggregate/${accountId}/${month.replace(
      '-',
      ''
    )}/summary/${kind}/${period}`
  ).then(makeTotalData)
}

export default {
  summary,
  dataTransfer,
  costAllocationTags,
  cdnUsage,
  commitment,
  summaryByPeriod,
}
